import { defineMessage } from 'services/localization';

export const messages = {
    mandatoryFieldsErrorText: defineMessage('please_fill_in_the_mandatory_fields'),
    poNegativeAmountErrorText: defineMessage('the_total_amount_of_the_rder_cannot_be_negative'),
    salesInvoiceNegativeAmountErrorText: defineMessage('the_total_amount_of_the_oice_cannot_be_negative'),
    billNegativeAmountErrorText: defineMessage('the_total_amount_of_the_bill_cannot_be_negative'),
    expenseNegativeAmountErrorText: defineMessage('the_total_amount_of_the_expense_cannot_be_negative'),
    poExceededAmountErrorText: defineMessage('the_total_amount_of_the_ase_order_cannot_exceed'),
    salesInvoiceExceededAmountErrorText: defineMessage('the_total_amount_of_the_s_invoice_cannot_exceed'),
    billExceededAmountErrorText: defineMessage('the_total_amount_of_the_bill_cannot_exceed'),
    expenseExceededAmountErrorText: defineMessage('the_total_amount_of_the_expense_cannot_exceed'),
    exceededAmountInCurrencyErrorText: defineMessage('the_total_amount_in_currency_cannot_exceed'),
    customerNotSpecifiedErrorText: defineMessage('you_must_select_a_custo__line_which_is_billable'),
    billableNotSpecifiedErrorText: defineMessage('the_tax_cannot_be_set_without_the_billable_status'),
    emailToVendorLengthExceeded: defineMessage('please_note_that_a_maxi_quickbooks_online_limit'),
    emailToVendorCcLengthExceeded: defineMessage('please_note_that_a_maxi_quickbooks_online_limit_1'),
    emailToVendorToEmpty: defineMessage('please_specify_email_to_address'),
    companyNameLengthErrorText: defineMessage('the_company_name_cannot_exceed_characters'),
    displayNameLengthErrorText: defineMessage('the_display_name_cannot_exceed_characters'),
    titleLengthErrorText: defineMessage('the_title_cannot_exceed_characters'),
    firstNameLengthErrorText: defineMessage('the_first_name_cannot_exceed_characters'),
    middleNameLengthErrorText: defineMessage('the_middle_name_cannot_exceed_characters'),
    lastNameLengthErrorText: defineMessage('the_last_name_cannot_exceed_characters'),
    suffixLengthErrorText: defineMessage('the_suffix_cannot_exceed_characters'),
    emailAddressLengthErrorText: defineMessage('the_email_cannot_exceed_characters'),
    websiteLengthErrorText: defineMessage('the_website_name_cannot_exceed_characters'),
    phoneLengthErrorText: defineMessage('phone_cannot_exceed_characters'),
    mobileLengthErrorText: defineMessage('mobile_cannot_exceed_characters'),
    faxLengthErrorText: defineMessage('fax_cannot_exceed_characters'),
    addressStreetLengthErrorText: defineMessage('address_cannot_exceed_characters'),
    cityLengthErrorText: defineMessage('citytown_cannot_exceed_characters'),
    regionLengthErrorText: defineMessage('countrystateprovince_cannot_exceed_characters'),
    postalCodeLengthErrorText: defineMessage('postcode_cannot_exceed_characters'),
    countryLengthErrorText: defineMessage('country_cannot_exceed_characters'),
    accountNumberLengthErrorText: defineMessage('account_no_cannot_exceed_characters'),
    unbillibleAccount: defineMessage('for_billable_expenses_y_ts_fixed_assets_or_cogs'),
    expenseBillableAccount: defineMessage('for_billable_expenses_y_ts_fixed_assets_or_cogs_1'),
    displayNameNotSpecifiedErrorText: defineMessage('display_name_cant_be_empty'),
    invalidDisplayNameErrorText: defineMessage('vendor_name_cannot_cont_following_symbols_lt_gt'),
    noEmojiInContactName: defineMessage('emojis_are_not_allowed_in_the_name'),
    wrongEmailErrorText: defineMessage('incorrect_email_format'),
    wrongWebsiteErrorText: defineMessage('please_check_url_format'),
    wrongPhoneErrorText: defineMessage('incorrect_phone_format'),
    isRequiredField: defineMessage('field_is_required_1'),
    bankAccountName: defineMessage('bank_account_name'),
    bankBranchIdentifier: defineMessage('bsb'),
    bsbIncorrectFormat: defineMessage('incorrect_bsb_number_fo_xxxx_where_x_is_a_digit'),
    bankAccountNumber: defineMessage('bank_account_number'),
    statement: defineMessage('statement_text'),
};
